import * as React from 'react';
import * as d3 from 'd3';
import {alertLevelColor} from '../../common/services'
export default class CustomDonutChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value, // expects value btn 0-100
            color: props.color,
            text: props.text
        }
        this.calculatePathValues = this.calculatePathValues.bind(this);
        this.donutValueRef = React.createRef();
    }

    componentDidMount() {
      this.calculatePathValues();
    }

    calculatePathValues() {
      let donutPath = this.refs.donutPath;
      let pathLength = donutPath.getTotalLength();
      let animate = d3.transition().duration(5000).ease(d3.easeLinear);

      d3.select(this.donutValueRef.current)
        .style("text-anchor", "middle")
        .attr('dx', 40);

      d3.select(donutPath)
        .attr("stroke-dashoffset", pathLength)
        .attr("stroke-dasharray", pathLength)
        .transition(animate)
        .attr("stroke-dashoffset", pathLength * (1 - this.props.value/100));
    }

    render() {
        return (
        <div style={{width:"100%"}}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 172 172">
            <g data-name="Layer 2">
              <g data-name="Layer 1">
                <circle ref="donutBg" cx="86" cy="86" r="75" stroke="#000" fill="none" stroke-linecap="round" stroke-miterlimit="10" stroke-width="22" stroke-dasharray="12.08 0"/>
                  <circle ref="donutPath" cx="86" cy="86" r="75" stroke={this.props.alertLevel ? alertLevelColor(this.props.alertLevel) : alertLevelColor('no')} fill="none" stroke-linecap="round" stroke-miterlimit="10" stroke-width="22" stroke-dasharray="12.08 0" transform="rotate(-90 86 86)"/>
                  <text ref={this.donutValueRef} fill={this.props.alertLevel ? alertLevelColor(this.props.alertLevel) : alertLevelColor('no')}  transform="translate(41.66 98.27)" font-size="32" font-family="RobotoCondensed-BoldItalic,Roboto Condensed" font-weight="700" font-style="italic">
                  {this.props.text}
                </text>
              </g>
            </g>
          </svg>
      </div>
      )
    }
}


// WEBPACK FOOTER //
// ./src/common/DataViz/customDonutChart.Component.js